@if ((subscriptionView$ | async); as subscriptionView) {
  <app-dropdown
    [options]="subscriptionView || []"
    [valueFormControl]="subscriptionView.length > 0 ? valueFormControl : emptyFormControl"
    [loading]="(loading$ | async) || false"
    [isMultiSelect]="true"
    [showToggleAll]="true"
    [fieldPlaceholder]="'export-creation.form.selectSubscriptions.placeholder' | translate">
  </app-dropdown>
}

